<template>
    <div v-if="show" class="form-modal doc-compare-modal flex flex-col flex-space-between book">
        <div class="flex flex-space-between flex-center-cz title border-box">
            <div class="margin-left-l font-s">文档对比</div>
            <img src="@/assets/images/guanbi.png" class="logo-18 margin-right-m pointer" @click="close"/>
        </div>       
        <div class="flex  body  border-box  border-box " style="height: calc(100% - 80px);"  >
            <div class="content half-width flex flex-col padding-m border-box" >
                <div class="flex flex-center-sp full-width flex-center-cz" style="height: 36px;">选中版本：{{leftFile.userName}}</div>
                <div class="margin-top-m book  full-height scroll border-box padding-l rtfDiv" style="background-color: #fff;" v-html="leftFile.content"></div>
            </div>
            <div class="content half-width flex flex-col padding-m border-box">
                <div class="flex flex-center-sp full-width flex-center-cz" style="height: 36px;">
                    <span>对比版本：</span>
                    <Select :data="verData" v-model="selectVer"  @change="verChange" style="width: 200px;"></Select>
                </div>
                <div class="margin-top-m book  full-height scroll border-box padding-l rtfDiv" style="background-color: #fff;"  v-html="rightFile.content"></div>
            </div>

        </div>
        <div class="flex flex-center-sp flex-center-cz toolbar border-box bk-color-white ">
            <div class="margin-right-s ui-no-button flex flex-center-cz flex-center-sp" @click="close">关闭</div>         
        </div>

    </div>
</template>

<script>
    import RichText from '@/components/richText/RichText' 
    import Select from '@/components/select/Select' 

    export default {
        name:'DocCompareModal',
        created() {
        },
        components:{RichText,Select},
        props:{
            open:{},
            leftId:{},
            files:{},
        },
        watch:{
            open: {
                handler(newValue) {
                    this.show = newValue;
                    if (newValue == true) {
                        console.log("leftId====", this.leftId);
                        console.log("files====", this.files);
                        this.leftFile = this.files.filter(item=>item.id === this.leftId)[0];
                        this.verData = [];
                        this.files.forEach(item => {
                            if (item.id != this.leftId) {
                                if (this.selectVer == null) {
                                    this.selectVer = item.id;
                                    this.rightFile = item;
                                }
                                this.verData.push({"text": item.userName, "value": item.id});
                            }                            
                        });
                    }
                },
                immediate: true,
                deep: true 
            },

        },
        data() {
            return {
                show: null,
                leftFile: null,
                rightFile: null,
                verData:[],
                selectVer:null,
                formData:{
                }
            }
        },
        methods:{
            verChange(data) {
                this.rightFile = this.files.filter(item=>item.id === data)[0];

            } ,
            close() {
                this.$emit("close")
            },
        }
   }
</script>

<style scoped>

    .rtfDiv >>> img {
        max-width: 100% ;
    }


    .form-modal {
        top:20px;
    }
    .form-modal .body{

        padding-bottom: 0px;

    }
    .doc-compare-modal {
        width: calc(100% - 100px);
        height: 820px;
        background-color: #ddd;
    }

    .doc-compare-modal .content {
        height: 715px;
    }
    

    .body .row {
        line-height: 40px;
    }
</style>


// WEBPACK FOOTER //
// src/views/modal/DocCompareModal.vue